import axios from "axios";

export const addCreditCardAction = async (payload) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/creditcards/addCreditCard`,
    payload.body,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );
  return response;
};

export const getAllCreditCardsAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/creditcards/allCreditCards`,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );
  return response;
};

export const deleteCreditCardAction = async (payload) => {
  const response = await axios.delete(
    `${process.env.REACT_APP_BASE_URL}/creditcards/deleteCreditCard?id=${payload.id}`,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );
  return response;
};

export const updateCreditCardAction = async (payload) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/creditcards/editCreditCard?id=${payload.creditCardId}`,
    payload.body,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );
  return response;
};

export const addBookingToCreditCardAction = async (payload) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/creditcards/addBookingsToCard?id=${payload.id}`,
    { bookingId: payload.bookingId },
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );
  return response;
};

export const creditCardDetailAction = async (payload) => {
  let response;
  if (payload.startDate && payload.endDate) {
    response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/creditcards/creditCardDetail?id=${payload.id}&startDate=${payload.startDate}&endDate=${payload.endDate}`,
      {
        headers: {
          Authorization: payload.token,
        },
      }
    );
  } else {
    response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/creditcards/creditCardDetail?id=${payload.id}`,
      {
        headers: {
          Authorization: payload.token,
        },
      }
    );
  }
  return response;
};
